import { render, staticRenderFns } from "./PartnerApprovalNew.vue?vue&type=template&id=0495236f&scoped=true"
import script from "./PartnerApprovalNew.vue?vue&type=script&lang=js"
export * from "./PartnerApprovalNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0495236f",
  null
  
)

export default component.exports